import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App.tsx";
import "./index.css";

// Initialize Sentry for production error monitoring
if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 0.1, // Capture 10% of transactions for performance monitoring
    // Session Replay
    replaysSessionSampleRate: 0.1, // Sample 10% of sessions for replay
    replaysOnErrorSampleRate: 1.0, // Always capture replay when an error occurs
    // Environment
    environment: import.meta.env.MODE,
    // Release tracking (use build hash)
    release: `mindcotine@${import.meta.env.VITE_BUILD_HASH || 'dev'}`,
    // Before sending events, filter out sensitive data
    beforeSend(event) {
      // Remove any potential PII from breadcrumbs
      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.map(breadcrumb => ({
          ...breadcrumb,
          data: breadcrumb.data ? {} : undefined, // Remove data to prevent PII leakage
        }));
      }
      return event;
    },
  });
}

createRoot(document.getElementById("root")!).render(<App />);
